export default ({
    state: {
        token: {
            name: null,
            token: null,
            expiration: null,
        }
    },
    getters: {
        isAuthenticated(state) {
            if (state.token.name !== 'solluti.com.br') {
                return null;
            }
            if (!state.token.token)
                return null;
            else {
                return state.token.token;
            }
        },
    },
    mutations: {
        setToken(state, payload) {
            state.token.name = payload.name;
            state.token.token = payload.token;
            state.token.expiration = payload.expiration + Date.now();
        },
        destroyToken(state) {
            state.token.name = null;
            state.token.token = null;
            state.token.expiration = null;
        },
    }
});
